import { store } from '@/redux/store'

import { W3ResponseType } from '../events'
import { w3Api } from '../w3Api'
import { CreateSpaceType, DetailSpaceType, ISpace, SpaceQueryType, TypeSpace } from './spaces.type'

export const endpoints = {
  createSpace: '/space',
  typeSpace: '/space/settings/load',
  followSpace: '/space/follow/:spaceId',
  unFollowSpace: '/space/un-follow/:spaceId',
  detailSpace: (id: string) => `/space/${id}`,
}
const spaceApi = w3Api.injectEndpoints({
  endpoints: (build) => ({
    createSpace: build.mutation<any, CreateSpaceType>({
      query: (args) => {
        return {
          url: endpoints.createSpace,
          method: 'POST',
          body: args,
        }
      },
      invalidatesTags() {
        const state = store.getState()
        return [{ type: 'Profile', id: state.root.auth?.user?.id }]
      },
    }),
    getTypeSetting: build.query<TypeSpace, void>({
      query: () => {
        return {
          url: endpoints.typeSpace,
          method: 'GET',
        }
      },
    }),
    getListSpace: build.query<W3ResponseType<ISpace[]>, SpaceQueryType>({
      query: (args) => {
        return {
          url: `${endpoints.createSpace}`,
          params: args,
        }
      },

      providesTags: (result, err, arg) =>
        result
          ? [
              ...(Array.isArray(result.data)
                ? result.data.map(({ id }: { id: string }) => ({ type: 'Spaces' as const, id }))
                : []),
              { type: 'Spaces', id: `isUserFollowing-${arg.isUserFollowing || 'default'}` }, // Use `id` for sortOption
              { type: 'Spaces', id: `categories-${arg.categories || 'default'}` }, // Use `id` for tags
              { type: 'Spaces' },
            ]
          : [{ type: 'Spaces' }],

      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        const { sortOption, isUserFollowing } = queryArgs
        const params = {
          endpointName,
          // page,
          isUserFollowing,
          sortOption: sortOption,
        }
        const cacheKey = JSON.stringify(params)
        return cacheKey
      },

      merge: (currentCache, newItems, { arg }) => {
        if (arg.page === 0) {
          return newItems
        }
        return {
          ...currentCache,
          data: [...currentCache.data, ...newItems.data],
          meta: {
            page: newItems.meta.page,
            totalPage: newItems.meta.totalPage,
            hasNext: newItems.meta.hasNext,
            hasPrev: newItems.meta.hasNext,
            limit: newItems.meta.limit,
            totalItem: newItems.meta.totalItem,
          },
        }
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg
      },
    }),

    followSpace: build.mutation<any, string>({
      query: (args) => {
        return {
          url: endpoints.followSpace.replace(':spaceId', args),
          method: 'POST',
          body: args,
        }
      },
    }),

    unFollowSpace: build.mutation<any, string>({
      query: (args) => {
        return {
          url: endpoints.unFollowSpace.replace(':spaceId', args),
          method: 'POST',
          body: args,
        }
      },
    }),

    getDetailSpace: build.query<DetailSpaceType, { spaceId: string }>({
      query: (args) => {
        return {
          url: endpoints.detailSpace(args.spaceId),
        }
      },
      providesTags: (result, error, arg) => {
        return [{ type: 'Spaces', id: arg.spaceId }]
      },
    }),

    updateSpace: build.mutation<any, { spaceId: string } & CreateSpaceType>({
      query: (args) => {
        return {
          url: endpoints.detailSpace(args.spaceId),
          method: 'PATCH',
          body: {
            name: args.name,
            description: args.description,
            profileImageUrl: args.profileImageUrl,
            bannerImageUrl: args.bannerImageUrl,
            tokenType: args.tokenType,
            socialUrls: args.socialUrls,
            categories: args.categories,
          },
        }
      },
      invalidatesTags(result, error, arg) {
        return [
          { type: 'Spaces', id: arg.spaceId },
          { type: 'Profile', id: arg.spaceId },
        ]
      },
    }),
  }),

  overrideExisting: true,
})

export const {
  useCreateSpaceMutation,
  useGetTypeSettingQuery,
  useGetListSpaceQuery,
  useFollowSpaceMutation,
  useUnFollowSpaceMutation,
  useGetDetailSpaceQuery,
  useUpdateSpaceMutation,
} = spaceApi
